/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Shareqralt2Inputs */

const en_shareqralt2 = /** @type {(inputs: Shareqralt2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`QR code for ${i?.title}`)
};

const de_shareqralt2 = /** @type {(inputs: Shareqralt2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`QR-Code für ${i?.title}`)
};

/**
* | output |
* | --- |
* | "QR code for {title}" |
*
* @param {Shareqralt2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const shareqralt2 = /** @type {((inputs: Shareqralt2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shareqralt2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shareqralt2(inputs)
	return de_shareqralt2(inputs)
});
export { shareqralt2 as "shareQrAlt" }